// src/data/projectsData.js
export const projectsData = [
  {
    id: "frontage-renovation",
    title: "Hardscaping - New Heated Driveway and Landscaping",
    location: "Sun Valley, ID",
    services: ["Design", "Build", "Planting"],

    // A/B/C summary (used by the listing page)
    a: {
      label: "Before",
      title: "Demolished entire front existing yard driveway",
      body:
        "Removed outdated and unattractive driveway to create entry and beautful and heated driveway.",
      image: "/images/projects/sageDemoDriveProject1.jpeg",
    },
    b: {
      label: "Finished",
      image: "/images/projects/sageAfterProject.jpeg",
      caption: "Completed entry axis with Hawthorne focal point",
      cta: { label: "View Full Gallery", to: "/Gallery" },
    },
    c: {
      label: "During",
      images: ["/images/projects/sageDriveDuringProject.jpg", "/images/projects/sageDriveHeatProject.jpg"],
      list: ["Selective demo", "Soil rebuild", "Irrigation re-zone", "Heated"],
      body:
        "Process highlights included selective demolition, rebuilding soil biology, and re-zoning irrigation to match microclimates.",
    },

    // Optional detailed story frames (if provided, detail page uses this exactly)
    // Otherwise the detail page will auto-build frames from a/c and skip b (since b is the hero).
    story: [
      {
        label: "Before",
        src: "/images/projects/p1-before.jpg",
        alt: "Before – frontage with aging plantings",
        text:
          "Original frontage had aging shrubs and compacted soils. Seasonal color never held, and irrigation ran unevenly across zones.",
      },
      {
        label: "During",
        src: "/images/projects/p1-during-1.jpg",
        alt: "During site prep",
        text:
          "We opened the soil profile, added organic matter, and reworked hardscape edges for clean planting geometry.",
      },
      {
        label: "During",
        src: "/images/projects/p1-during-2.jpg",
        alt: "During plant set",
        text:
          "Specimen placement established a strong entry axis. Irrigation zones were right-sized to canopy and exposure.",
      },
      // Tip: You can repeat the finished image here if you want it again at the end,
      // but by default the detail page will NOT duplicate the hero image.
    ],
  },

  {
    id: "patio-privacy",
    title: "Patio Privacy & Four-Season Layering",
    location: "Ketchum, ID",
    services: ["Design", "Build"],

    a: {
      label: "Before",
      title: "Underused patio edge",
      body:
        "Wind exposure and sun made this area uncomfortable. Plant palette lacked four-season interest and screening.",
      image: "/images/projects/p2-before.jpg",
    },
    b: {
      label: "Finished",
      image: "/images/projects/p2-after.jpg",
      caption: "Layered evergreens with seasonal accents",
      cta: { label: "Explore Projects", to: "/Projects" },
    },
    c: {
      label: "During",
      images: ["/images/projects/p2-during-1.jpg", "/images/projects/p2-during-2.jpg"],
      list: ["Staging", "Set grades", "Plant in sequence"],
      body:
        "We staged materials, established grades for drainage, and layered textures for year-round screening and color.",
    },
  },
];
